"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _bootstrapModal = require("../bootstrap-modal");
var _inputGroupAddon = require("../input-group-addon");
var _searchDateTimeForm = require("./search-date-time-form");
var _searchDateTimeHoc = _interopRequireDefault(require("./search-date-time-hoc"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var DateTimeModal = /*#__PURE__*/function (_React$Component) {
  _inherits(DateTimeModal, _React$Component);
  function DateTimeModal(props) {
    var _this;
    _classCallCheck(this, DateTimeModal);
    _this = _callSuper(this, DateTimeModal, [props]);
    _this.state = {
      showModal: false
    };
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.toggleModal = _this.toggleModal.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(DateTimeModal, [{
    key: "toggleModal",
    value: function toggleModal() {
      var showModal = this.state.showModal;
      this.setState({
        showModal: !showModal
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.closeModal();
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        displayDateTime = _this$props.displayDateTime,
        defaultLabel = _this$props.defaultLabel;
      var isSelected = !!displayDateTime;
      var buttonClassName = (0, _classnames.default)('btn btn-default btn-outlined-light btn-block remove-click-styling flex center', {
        'selected-filter': isSelected
      });
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
        className: buttonClassName,
        onClick: this.toggleModal
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "search",
        src: "/web-search/assets/images/calendar-".concat(isSelected ? 'teal' : 'gray', ".svg?v=rb")
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "margin-md-left ellipsis"
      }, displayDateTime || defaultLabel || /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "search.date_time_modal.date_and_time",
        defaultMessage: "Date & Time"
      }))), /*#__PURE__*/_react.default.createElement(_bootstrapModal.BootstrapModal, {
        showModal: this.state.showModal,
        modalSize: "sm-size",
        modalClass: "activity-modal",
        onClose: this.closeModal,
        body: /*#__PURE__*/_react.default.createElement("div", {
          className: "container-fluid"
        }, /*#__PURE__*/_react.default.createElement(_searchDateTimeForm.DateTimeForm, _extends({}, this.props, {
          dateColClass: "text-center"
        })))
      }));
    }
  }]);
  return DateTimeModal;
}(_react.default.Component);
DateTimeModal.propTypes = {
  displayDateTime: _propTypes.default.string,
  defaultLabel: _propTypes.default.string,
  btnClass: _propTypes.default.string
};
var _default = exports.default = (0, _searchDateTimeHoc.default)(DateTimeModal);